import { SVGProps } from 'react';

export const GithubLogo = ({
  width = 20,
  height = 20,
}: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 1C5.02958 1 1 5.02958 1 10C1 14.2497 3.94646 17.8092 7.9075 18.7528C7.70258 18.704 7.49938 18.6493 7.3 18.587V16.525C7.3 16.525 6.9625 16.6375 6.5125 16.6375C5.25354 16.6375 4.7305 15.5142 4.6 14.95C4.52073 14.6063 4.31373 14.2805 4.0915 14.0815C3.826 13.8447 3.70173 13.844 3.7 13.763C3.69654 13.5931 3.92777 13.6 4.0375 13.6C4.6 13.6 5.02646 14.1985 5.22446 14.508C5.71496 15.2719 6.24146 15.4 6.5125 15.4C6.85 15.4 7.14146 15.3495 7.34223 15.2525C7.435 14.599 7.72577 14.0168 8.2 13.6C6.0895 13.178 4.6 11.9675 4.6 10C4.6 8.98646 5.00673 8.05496 5.6845 7.30277C5.61527 7.1065 5.5 6.70946 5.5 6.0625C5.5 5.635 5.52977 5.11023 5.725 4.6C5.725 4.6 7.00854 4.609 8.21904 5.75546C8.77773 5.59277 9.37554 5.5 10 5.5C10.6245 5.5 11.2223 5.59277 11.781 5.75546C12.9915 4.609 14.275 4.6 14.275 4.6C14.4713 5.11023 14.5 5.635 14.5 6.0625C14.5 6.76 14.4072 7.16673 14.3505 7.34223C15.0075 8.0875 15.4 9.00446 15.4 10C15.4 11.9675 13.9105 13.178 11.8 13.6C12.3635 14.095 12.7 14.816 12.7 15.625V18.587C12.5006 18.6497 12.2978 18.704 12.0925 18.7528C16.0535 17.8092 19 14.2497 19 10C19 5.02958 14.9704 1 10 1ZM10.6276 18.9758C10.4202 18.9903 10.2112 19 10 19C10.2112 19 10.4199 18.99 10.6276 18.9758ZM10 19C9.78885 19 9.57977 18.9903 9.37242 18.9758C9.58012 18.99 9.78885 19 10 19ZM9.23431 18.9654C8.81304 18.9297 8.39973 18.8653 7.99715 18.7736C8.40008 18.865 8.81304 18.9297 9.23431 18.9654Z"
        fill="currentColor"
      />
    </svg>
  );
};
